import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionBuyTrialResponse = { url: string };

export class SubscriptionBuyTrialAPICall extends APICallV3Post<SubscriptionBuyTrialResponse> {
    _method = 'billing/subscription/trial';
}
